/*
 * Значок состояния. Из макета, карточка «Вкладки · чипы · подсказка · бейджи»:
 * Подтверждена · Ожидает · В работе · Завершён · Не пришёл · Первый визит ·
 * Ограничена онлайн-запись.
 */

.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2.5px 9px;
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.02em;
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  /* В дизайн-системе здесь nowrap. Снято: в колонке 360 или в ячейке таблицы
     немецкое «Online-Buchung eingeschränkt» вылезло бы за край вместо переноса. */
  white-space: normal;
  text-wrap: pretty;
  min-width: 0;
}

.dot {
  flex: none;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.ok {
  background: var(--status-in-progress-bg);
  color: var(--status-in-progress-fg);
}

.warn {
  background: var(--status-pending-bg);
  color: var(--status-pending-fg);
}

.info {
  background: var(--info-bg);
  color: var(--info-fg);
}

.gray {
  background: var(--status-completed-bg);
  color: var(--status-completed-fg);
}

.error {
  background: var(--status-no-show-bg);
  color: var(--status-no-show-fg);
}

/* Обводка вместо заливки: значок, который не сообщает состояния записи,
   а помечает самого клиента («Первый визит»). */
.outline {
  background: transparent;
  color: var(--info-fg);
  border-color: var(--info-border);
}

/* Фирменный — самый заметный. Им помечено ограничение, наложенное салоном. */
.brand {
  background: var(--badge-brand-bg);
  color: var(--badge-brand-fg);
}
